import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'outcomesParticipantCharts',
    label: 'Outcomes Participant Charts',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
